<template>
  <div class="o-container o-container--xlarge o-admin__home">
    <div class="o-grid o-grid--wrap o-grid--no-gutter">
      <div
        class="o-grid__cell o-grid__cell--width-100 o-grid__cell--width-20@medium u-display-block@medium"
      >
        <bos-admin-navigation />
      </div>
      <div class="o-grid__cell o-grid__cell--offset-5">
        <router-view :key="$route.fullPath"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import BosAdminNavigation from '@/components/BosAdminNavigation'

export default {
  name: 'AdminHome',
  components: { BosAdminNavigation }
}
</script>

<style lang="scss" scoped>
.o-admin__home {
  padding: 4rem 20px;

  section {
    margin-bottom: 8rem;
  }
}
</style>
